<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="900"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="observer"
    >
      <v-card flat>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>紙マニフェスト返却日（一括登録）</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="form"
          style="max-height: 60vh;overflow-y: auto;"
          class="mt-2"
        >
          <paper-register-form :manifest="form" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import paperRegisterForm from './forms/_PaperRegisterForm.vue'
import { mapActions } from 'vuex'

export default {
  name: "BulkPaperRegisterDialog",
  components: {
    paperRegisterForm
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: null,
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.form = null
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestPaperRegister', {
      fetchPaperManifestReturnVote: 'new',
      registerPaperManifestReturnVotes: 'create'
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.register()
        }
      })
    },
    /**
     * 初期表示
     */
    setVariable () {
      this.fetchPaperManifestReturnVote().then((content) => {
        this.form = content
      })
    },
    /**
     * 登録処理
     */
    register () {
      const parameters = {
        manifest_ids: this.manifestIds,
        a_return_date: this.form.a_return_date,
        a_return_target: this.form.a_return_target,
        b2_return_date: this.form.b2_return_date,
        b2_return_target: this.form.b2_return_target,
        b4_return_date: this.form.b4_return_date,
        b4_return_target: this.form.b4_return_target,
        b6_return_date: this.form.b6_return_date,
        b6_return_target: this.form.b6_return_target,
        d_return_date: this.form.d_return_date,
        d_return_target: this.form.d_return_target,
        e_return_date: this.form.e_return_date,
        e_return_target: this.form.e_return_target,
        b1_return_date: this.form.b1_return_date,
        b1_return_target: this.form.b1_return_target,
        c1_return_date: this.form.c1_return_date,
        c1_return_target: this.form.c1_return_target,
        c2_return_date: this.form.c2_return_date,
        c2_return_target: this.form.c2_return_target,
      }
      this.registerPaperManifestReturnVotes({ params: parameters }).then(() => {
        this.$emit('registerEvent')
      })
    },
  }
}
</script>
